import React from "react";
import FormSubmitProps from "../../../types/FormSubmitProps";
import PersonalMessage from "../AbstractLitigationCase/PersonalMessage";
import { AbstractCase } from "../../../types/Entities/AbstractCase";

type ContractDescriptionProps = {
  submitProps: FormSubmitProps;
  product: AbstractCase;
  applicationStatus: number;
};

export default function ContractDescription({ submitProps, product, applicationStatus }: ContractDescriptionProps) {
  return <PersonalMessage submitProps={submitProps} product={product} applicationStatus={applicationStatus} />;
}
